import { useEffect, useRef } from 'react';

export default function useLayoutValuesRefresh(locationId, refresh) {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    const changed = (event) => {
      if (!event.detail?.subjectId || event.detail.subjectId === locationId)
        callback.current();
    };
    window.addEventListener('layout-values-changed', changed);
    return () => window.removeEventListener('layout-values-changed', changed);
  }, [locationId]);
}
